/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctString } from '../../../../Fct/generics';
import { FaTag } from 'react-icons/fa';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var Symbol = createPlugin({
    protocol: 'ERC20',
    type: 'GETTER',
    method: 'symbol',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                    isPreview: true,
                    icon: FaTag,
                }),
                methodParams: {},
            },
            output: {
                symbol: new FctString({ innerIndex: 0 }),
            },
        });
    },
});
